export type MailColorLabel = "red" | "orange" | "yellow" | "green" | "blue" | "purple";

export type MailMessageLabel = {
  favorite: boolean;
  color: MailColorLabel | null;
};

export const MAIL_COLOR_LABELS: ReadonlyArray<{
  id: MailColorLabel;
  label: string;
  swatch: string;
}> = [
  { id: "red", label: "Rouge", swatch: "#ef4444" },
  { id: "orange", label: "Orange", swatch: "#f97316" },
  { id: "yellow", label: "Jaune", swatch: "#eab308" },
  { id: "green", label: "Vert", swatch: "#22c55e" },
  { id: "blue", label: "Bleu", swatch: "#3b82f6" },
  { id: "purple", label: "Violet", swatch: "#a855f7" },
];

export function mailColorLabelCss(color?: MailColorLabel | null): string | undefined {
  return MAIL_COLOR_LABELS.find((c) => c.id === color)?.swatch;
}

export type InboxListFilter = {
  unreadOnly: boolean;
  importantOnly: boolean;
  favoriteOnly: boolean;
  attachmentsOnly: boolean;
  colorLabel: MailColorLabel | null;
};

export const INBOX_FILTER_DEFAULT: InboxListFilter = {
  unreadOnly: false,
  importantOnly: false,
  favoriteOnly: false,
  attachmentsOnly: false,
  colorLabel: null,
};

export function applyInboxListFilter<T extends {
  seen: boolean;
  flagged?: boolean;
  favorite?: boolean;
  hasAttachments?: boolean;
  colorLabel?: MailColorLabel | null;
}>(messages: T[], filter: InboxListFilter): T[] {
  return messages.filter((m) => {
    if (filter.unreadOnly && m.seen) return false;
    if (filter.importantOnly && !m.flagged) return false;
    if (filter.favoriteOnly && !m.favorite) return false;
    if (filter.attachmentsOnly && !m.hasAttachments) return false;
    if (filter.colorLabel != null && m.colorLabel !== filter.colorLabel) return false;
    return true;
  });
}

export function inboxFilterIsActive(filter: InboxListFilter): boolean {
  return (
    filter.unreadOnly ||
    filter.importantOnly ||
    filter.favoriteOnly ||
    filter.attachmentsOnly ||
    filter.colorLabel != null
  );
}

/** Non lus → requête IMAP ; le reste → filtre client sur la liste chargée. */
export function splitInboxListFilter(filter: InboxListFilter): {
  imapUnreadOnly: boolean;
  clientFilter: InboxListFilter;
} {
  return {
    imapUnreadOnly: filter.unreadOnly,
    clientFilter: { ...filter, unreadOnly: false },
  };
}

export function inboxClientFilterIsActive(filter: InboxListFilter): boolean {
  return (
    filter.importantOnly ||
    filter.favoriteOnly ||
    filter.attachmentsOnly ||
    filter.colorLabel != null
  );
}
